export default {"src":"/_next/static/media/strike.f788b6e9.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};